<!-- /news's Subscribe pill, beside Expand all (2026-10-23, Seán's mockup): the mailing-list
     dialog (signed out, #sign-in first). Its look follows the account's lists:
     - none (or signed out): "Subscribe", an outlined bell, in orange: worth a look, nothing
       wrong (DESIGN.md § 5, the two signal colours);
     - some: "Subscriptions", a filled bell, in the brand green;
     - all three: the same, the bell ringing.
     "Subscribe" opens #subscribe, subscribing them to all three as the dialog opens;
     "Subscriptions" opens #subscriptions, the lists as they are (Seán, 2026-10-23). -->
<template>
  <button type="button" :class="['subscribe', state]" @click="openSubscribe">
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path class="bell" d="M6 16.5V11a6 6 0 0 1 12 0v5.5l1.5 1.5h-15z" />
      <path class="clapper" d="M10 20.5a2 2 0 0 0 4 0" />
      <template v-if="state === 'all'">
        <path class="ring" d="M3.5 9.5a8.5 8.5 0 0 1 2.5-5" />
        <path class="ring" d="M20.5 9.5a8.5 8.5 0 0 0-2.5-5" />
      </template>
    </svg>
    {{ state === "none" ? "Subscribe" : "Subscriptions" }}
  </button>
</template>

<script setup>
import {computed} from "vue";
import {useRouter} from "vue-router";
import useUserSafe from "@/composables/useUserSafe";
import {SUBSCRIPTION_LISTS, getSubscribedTo} from "@/composables/subscriptionLists";

const router = useRouter();
const {user} = useUserSafe();
const state = computed(() => {
  const count = getSubscribedTo(user.value?.publicMetadata).length; // signed out: none
  if (!count) return "none";
  return count === SUBSCRIPTION_LISTS.length ? "all" : "some";
});
const openSubscribe = () => {
  router.push({hash: state.value === "none" ? "#subscribe" : "#subscriptions"});
};
</script>

<style scoped>
/* as tall as Expand all beside it (Index.vue's .toggle-all), on a faint fill of its own;
   global.css's button card reset */
.subscribe {
  --pill-color: var(--orange-on-light);
  display: inline-flex;
  align-items: center;
  gap: 0.4em;
  margin: 0;
  padding: 0.15rem 0.85rem 0.15rem 0.65rem;
  border: none;
  border-radius: 17px;
  box-shadow: none;
  background: rgba(0, 0, 0, 0.06);
  color: var(--pill-color);
  font: inherit;
  font-size: 0.85em;
  font-weight: 700;
  line-height: 1.4;
  white-space: nowrap;
  cursor: pointer;
}
.subscribe:is(.some, .all) {
  --pill-color: var(--brand-dark-color);
}
.darkMode .subscribe {
  --pill-color: var(--orange-on-dark);
  background: rgba(255, 255, 255, 0.1);
}
.darkMode .subscribe:is(.some, .all) {
  --pill-color: var(--brand-color);
}
.subscribe:hover {
  background: rgba(0, 0, 0, 0.11);
}
.darkMode .subscribe:hover {
  background: rgba(255, 255, 255, 0.16);
}
.subscribe:focus-visible {
  outline: 2px solid var(--brand-dark-color);
  outline-offset: 2px;
}
svg {
  width: 1.25em;
  height: 1.25em;
  flex: 0 0 auto;
  fill: none;
  stroke: currentColor;
  stroke-width: 1.8;
  stroke-linecap: round;
  stroke-linejoin: round;
}
/* subscribed: the bell filled */
:is(.some, .all) .bell {
  fill: currentColor;
}
</style>
